import { get, isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { useMediaQuery } from 'react-responsive/src';
import { NavigationUtil } from 'utils/NavigationUtil';
import { HomeActions } from 'modules/home/actions';
import { HomeSelector } from 'modules/home/selector';
import { ProductActions } from 'modules/product/actions';
import { ProductSelector } from 'modules/product/selector';
import { ProductBrowserAction } from 'modules/productBrowser/actions';
import { ProductBrowserSelector } from 'modules/productBrowser/selector';
import { ProjectActions } from 'modules/project/actions';
import { PageLoader } from 'components/molecules/pageLoader';
import ProductBanner from 'components/organisms/productDetailsBanner';
import { ContactUsSection } from 'components/templates/contactUsSection';
import FooterSection from 'components/templates/footer';
import { GetInTouchModal } from 'components/templates/getInTouchModal';
import ImageGallerySection from 'components/templates/imageGallerySection';
import PageTemplate from 'components/templates/pageTemplate';
import ProductBrowser from 'components/templates/productBrowser';
import { ProductVariationsSection } from 'components/templates/productVariationsSection';
import ProjectBrowser from 'components/templates/projectBrowser';
import { ShareModal } from 'components/templates/shareModal';
import { VirtualTourSection } from 'components/templates/virtualTourSection';
import { RouteNames } from 'router';
import { LocationSelector } from 'modules/location/selector';
import { LocationActions } from 'modules/location/actions';
import RenderSEO from 'components/atoms/renderSEO';
import { HeaderButtons } from 'components/atoms/headerButtons';
import { PRODUCT_FILE_DOWNLOAD_URL } from 'config/env';
import { DownloadBrochureModal } from 'components/templates/downloadBrochureModal';
import { FooterSelector } from 'modules/footerLink/selector';
import { FooterActions } from 'modules/footerLink/actions';

const ProductDetails = props => {
  const {
    isLoading,
    getVerticals,
    verticals,
    verticalId,
    getContactDetails,
    contact,
    getSiteSettings,
    siteSettings,
    getGalleryForProduct,
    gallery,
    getProjects,
    projectList,
    footerLink,
    getFooterLinkData,
    getProductDetails,
    productDetails,
    getProductBrowser,
    productsInProducts,
    getVersionsForProduct,
    versions,
    getUserLocation,
    userLocation,
    getBannerData,
  } = props;

  const product_url_slug = props.match.params.productSlug;

  const isMobile = useMediaQuery({ query: '(max-device-width: 560px)' });
  let [theme, setTheme] = useState(isMobile ? 'dark-theme' : 'light-theme');
  const [isGetInTouchModalOpen, setIsGetInTouchModalOpen] = useState(false);
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  // const [isBrochureModalOpen, setIsBrochureModalOpen] = useState(false);
  const [mapView, setMapView] = useState(false);

  useEffect(() => {
    getProductDetails(product_url_slug);
    getContactDetails();
    getSiteSettings();
    getVerticals();
    getGalleryForProduct(product_url_slug);
    getProductBrowser();
    getProjects();
    getFooterLinkData();
    getVersionsForProduct(product_url_slug);
    getUserLocation();
    getBannerData();
  }, [product_url_slug]);

  if (isLoading) {
    return <PageLoader isMobile={isMobile} />;
  }
  if (
    !productDetails ||
    !projectList ||
    !gallery ||
    !versions ||
    !siteSettings ||
    !verticals ||
    !contact ||
    !userLocation ||
    !footerLink
  ) {
    return null;
  }

  const productName =
    get(productDetails, 'productDetails[0].product_name', '') +
    get(productDetails, 'productDetails[0].productVersion', '');
  const metaTagSEO = productDetails.productDetails[0].metaTagSEO;
  const virtualTours = get(
    productDetails,
    'productDetails[0].virtualTours',
    []
  );

  const updateMapView = (theme, view) => {
    setTheme(theme);
    setMapView(view);
  };

  // Get in touch
  const closeGetInTouchModal = () => {
    setIsGetInTouchModalOpen(false);
  };

  // Brochure
  // const onBrochureClick = () => {
  //   setIsBrochureModalOpen(true);
  // };
  //
  // const closeBrochureModal = () => {
  //   setIsBrochureModalOpen(false);
  // };

  // Share
  const closeShareModal = () => {
    setIsShareModalOpen(false);
  };
  const CampaignCode = contact.campaignCode ? contact.campaignCode : '';
  let product = productDetails && productDetails.productDetails[0];
  const CampaignBrochureCode = product.brochure_campaign_code
    ? product.brochure_campaign_code
    : '';
  let pdfUrl =
    product.productBrochure &&
    `${PRODUCT_FILE_DOWNLOAD_URL}${product.productBrochure}`;
  const componentList = [
    ...(!isEmpty(productDetails)
      ? [
          {
            component: ProductBanner,
            data: { data: productDetails },
            theme: isMobile ? 'dark-theme' : 'light-theme',
            sectionId: 'banner',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Homes',
                breadcrumbLink: RouteNames.homes,
              },
              {
                breadcrumbName: `${productName}`,
                breadcrumbLink: '#',
              },
            ],
          },
        ]
      : []),
    ...(!isEmpty(versions)
      ? [
          {
            component: ProductVariationsSection,
            data: {
              data: versions,
              productName,
              // onBrochureClick,
              pdfUrl,
            },
            theme: 'light-theme',
            sectionId: 'variations',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Homes',
                breadcrumbLink: RouteNames.homes,
              },
              {
                breadcrumbName: `${productName} \u2014 Variations`,
                breadcrumbLink: '#',
              },
            ],
          },
        ]
      : []),
    ...(!isEmpty(gallery)
      ? [
          {
            component: ImageGallerySection,
            data: {
              images: gallery,
            },
            theme: 'dark-theme',
            sectionId: 'gallery',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Homes',
                breadcrumbLink: RouteNames.homes,
              },
              {
                breadcrumbName: `${productName} \u2014 Gallery`,
                breadcrumbLink: '#',
              },
            ],
          },
        ]
      : []),
    ...(!isEmpty(virtualTours)
      ? [
          {
            component: VirtualTourSection,
            data: {
              data: virtualTours || [],
            },
            theme: isMobile ? 'dark-theme' : 'light-theme',
            sectionId: 'virtual-tours',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Homes',
                breadcrumbLink: RouteNames.homes,
              },
              {
                breadcrumbName: `${productName} \u2014 360\u00B0 Tour`,
                breadcrumbLink: '#',
              },
            ],
          },
        ]
      : []),
    ...(!isEmpty(projectList.list)
      ? [
          {
            component: ProjectBrowser,
            data: {
              data: projectList,
              userLocation,
              updateMapView,
              mapView,
              product: productDetails.productDetails[0],
              breadcrumb: productName,
              type: 'projects',
            },
            sectionId: 'projects',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Homes',
                breadcrumbLink: RouteNames.homes,
              },
              {
                breadcrumbName: `${productName} \u2014 Project Browser`,
                breadcrumbLink: '#',
              },
            ],
            theme: isMobile ? 'dark-theme' : 'light-theme',
          },
        ]
      : []),
    ...(!isEmpty(productsInProducts)
      ? [
          {
            component: ProductBrowser,
            data: {
              productData: productsInProducts,
              productsSelector: ProductBrowserSelector.getProductsInProducts,
              breadcrumb: productName,
            },
            sectionId: 'products',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Homes',
                breadcrumbLink: RouteNames.homes,
              },
              {
                breadcrumbName: `${productName} \u2014 Product Browser`,
                breadcrumbLink: '#',
              },
            ],
            theme: 'dark-theme',
          },
        ]
      : []),
    {
      component: ContactUsSection,
      data: {
        contact,
        verticals,
        verticalId,
        projectName: productName,
        callPostLeadAPI: true,
      },
      location: props,
      sectionId: 'contact',
      breadcrumbList: [
        {
          breadcrumbName: 'TotalEnvironment',
          breadcrumbLink: RouteNames.landing,
        },
        {
          breadcrumbName: 'Homes',
          breadcrumbLink: RouteNames.homes,
        },
        {
          breadcrumbName: 'Contact Us',
          breadcrumbLink: '#',
        },
      ],
      theme: 'light-theme',
    },
    {
      component: FooterSection,
      theme: 'dark-theme',
      sectionId: 'te-links',
      breadcrumbList: [
        {
          breadcrumbName: 'TotalEnvironment',
          breadcrumbLink: RouteNames.landing,
        },
        {
          breadcrumbName: 'Homes',
          breadcrumbLink: RouteNames.homes,
        },
        {
          breadcrumbName: 'Links',
          breadcrumbLink: '#',
        },
      ],
      data: { siteSettings, footerLink },
    },
  ];

  return (
    <div>
      <RenderSEO
        metaTags={metaTagSEO}
        currentRouteName={`homes/${product_url_slug}`}
      />
      <PageTemplate
        theme={theme}
        componentList={componentList}
        updateTheme={e => setTheme(e)}
        verticals={verticals}
        siteSettings={siteSettings}
        campaignCode={CampaignCode}
        salesEmail={contact.email}
        headerButtons={
          <HeaderButtons
            shareTheme={'dark'}
            getInTouchTheme={'light'}
            setIsModalOpen={setIsGetInTouchModalOpen}
            setIsShareModalOpen={setIsShareModalOpen}
          />
        }
      />
      {/*<DownloadBrochureModal*/}
      {/*  isOpen={isBrochureModalOpen}*/}
      {/*  onClosePress={closeBrochureModal}*/}
      {/*  campaignCode={CampaignBrochureCode}*/}
      {/*  projectInterested={productName}*/}
      {/*  salesEmail={contact.email}*/}
      {/*  callPostLeadAPI={true}*/}
      {/*  pdfUrl={pdfUrl}*/}
      {/*/>*/}
      <GetInTouchModal
        isOpen={isGetInTouchModalOpen}
        onClosePress={closeGetInTouchModal}
        campaignCode={CampaignCode}
        salesEmail={contact.email}
        callPostLeadAPI={true}
        verticalId={verticalId}
        projectInterested={productName}
      />
      <ShareModal
        isOpen={isShareModalOpen}
        onClosePress={closeShareModal}
        callPostLeadAPI={true}
      />
    </div>
  );
};

const mapStateToProps = (state, props) => {
  const verticalKey = NavigationUtil.getVerticalKeyForLocation(props.location);

  return {
    isLoading:
      ProductSelector.isLoading(state) || FooterSelector.isLoading(state),
    contact: HomeSelector.getContactForProduct(state),
    siteSettings: HomeSelector.getSiteSettings(state),
    verticals: HomeSelector.getVerticals(state),
    verticalId: HomeSelector.getVerticalIdForKey(verticalKey),
    gallery: ProductSelector.getGallery(state),
    footerLink: FooterSelector.getFooterData(state),
    productDetails: ProductBrowserSelector.getProductDetailsData(state),
    productsInProducts: ProductBrowserSelector.getProductsInProducts(state),
    projectList: ProductSelector.getProjects(state),
    versions: ProductSelector.getVersions(state),
    userLocation: LocationSelector.getUserLocation(state),
  };
};

const mapDispatchToProps = dispatch => {
  const {
    getContactDetails,
    getVerticals,
    getSiteSettings,
    getBannerData,
  } = HomeActions;
  const { getProductDetails, getProductBrowser } = ProductBrowserAction;
  const { getGalleryForProduct, getVersionsForProduct } = ProductActions;
  const { getProjects } = ProjectActions;
  const { getFooterLinkData } = FooterActions;
  const { getUserLocation } = LocationActions;
  return bindActionCreators(
    {
      getContactDetails,
      getSiteSettings,
      getVerticals,
      getGalleryForProduct,
      getProductBrowser,
      getProductDetails,
      getProjects,
      getVersionsForProduct,
      getUserLocation,
      getFooterLinkData,
      getBannerData,
    },
    dispatch
  );
};
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ProductDetails)
);
